import { React, Helper, Link, TextInput2 as TextInput, RadioInput2 as RadioInput, DropDown2 as DropDown } from "../../../../common";

const RenderNumberOfCoApplicant = (props) => {
    const { num, row, errors, onInputChanged, onBlurError, onInputClicked } = props;
    return (
        <li className="formContentIVcol">
            <div className="form1003ContentHead">Co-Applicant {num} Name</div>
            <div className="formMandatory">*</div>
            <div className="usericon"></div>
            <TextInput
                errors={errors}
                path={`applicants.${num}.borrower.firstName`}
                value={Helper.GetJsonValue(row, `applicants.${num}.borrower.firstName`)}
                onInputChildChanged={onInputChanged}
                required={true}
                onBlurError={onBlurError}
                onInputClicked={onInputClicked}
                requiredMessage={'Co-Applicant Name is required'}
                dataRequired={true}
            />
        </li>
    );
}

const Component = (props) => {
    const { row, loanOffierDisabled, errors, onInputChanged, loanOfficers, howdoyouhear,
        onBlurError, onInputClicked } = props;

    const [statesList, setStatesList] = React.useState([]);

    React.useEffect(() => {
        let _stateId = row?.loanOfficerStateId || 0;
        if (parseInt(_stateId) > 0) {
            let tmp = loanOfficers.find((x) => parseInt(x.id) === parseInt(_stateId)) || {};
            let _row = {
                loanOfficerId: tmp.id,
                loanOfficerEmail: tmp.email,
                loanOfficerPhone: tmp.work_phone,
                loanOfficerNMLSId: tmp.nmls_id,
                loanOfficerStateId: tmp.id,
                loanOfficerLicenseState: tmp.state,
                loanOfficerLicenseID: tmp.license,
                loanOfficer: tmp.fullname,
            }
            onInputChanged('LoanOfficerInfo', _row);
        }
    }, [loanOfficers, onInputChanged, row?.loanOfficerStateId]);

    React.useEffect(() => {
        setStatesList([]);
        let keyId = row?.loanOfficerId || 0;
        if (parseInt(keyId) > 0) {
            let _tmp = loanOfficers.filter((x) => parseInt(x.id) === parseInt(keyId))
                .map((z) => { return { _id: z.id, value: z.id, text: z.state } });
            _tmp.splice(0, 0, { _id: 0, value: 0, text: "Select" });
            setStatesList(_tmp);
        }
    }, [loanOfficers, row?.loanOfficerId]);

    return (
        <>
            <div className="form1003BlkHead">
                <div className="formHeadContent">Other Details</div>
                <div className="form1003Blk_right">&nbsp;</div>
            </div>
            <div className="form1003ContentBlk">
                <ul className="formContentIVcol">
                    <li className="formContentIVcol">
                        <div className="form1003ContentHead">
                            Type of Credit
                        </div>
                        <div className="formMandatory">*</div>
                        <ul className="form_A" data-opts={true} data-req-msg={"Type of Credit?"} data-id={`borrowerCreditType`}>
                            <RadioInput
                                errors={errors}
                                name={"borrowerCreditType"}
                                value={Helper.ToString(row?.borrowerCreditType)}
                                options={Helper.TypeOfCredits()}
                                uselabel={true}
                                onInputChildChanged={onInputChanged}
                            />
                        </ul>
                        {/* <div style="color:red">If No is selected, there will be 5 steps. Step 4 from top has to be removed</div> */}
                    </li>

                    {row?.borrowerCreditType === "Joint" && (
                        <>
                            <li className="formContentIVcol">
                                <div className="form1003ContentHead">
                                    Is there a Co-Applicant?
                                </div>
                                <Link
                                    to="#"
                                    title="Info"
                                    onClick={(e) => window.pop("info_coapplicant")}
                                >
                                    <div className="formTip"></div>
                                </Link>
                                <ul className="form_A" data-opts={true} data-req-msg={"Is there a Co-Applicant?"} data-id={`coApplicantIndicator`}>
                                    <RadioInput
                                        errors={errors}
                                        path={"coApplicantIndicator"}
                                        value={Helper.ToUndefinedCheck(row?.coApplicantIndicator)}
                                        options={Helper.Options()}
                                        uselabel={false}
                                        onInputChildChanged={onInputChanged}
                                    />
                                </ul>
                                {/* <div style="color:red">If No is selected, there will be 5 steps. Step 4 from top has to be removed</div> */}
                            </li>
                            {row?.coApplicantIndicator && (
                                <>
                                    <li className="formContentIVcol">
                                        <div className="form1003ContentHead">Total Number of Co-Applicants</div><div className="formMandatory">*</div>
                                        <div className="hastagicon"></div>
                                        <DropDown
                                            errors={errors}
                                            path={"coApplicantCount"}
                                            value={Helper.ToString(row?.coApplicantCount)}
                                            items={Helper.NumberList(1, 5)}
                                            displayName={"text"}
                                            displayValue={"value"}
                                            onInputChildChanged={onInputChanged}
                                            onInputClicked={onInputClicked}
                                            dataRequired={true}
                                            requiredMessage={"Total Number of Co-Applicants"}
                                            indexValue={1}
                                        />
                                    </li>
                                    {[...Array(Helper.GetApplicantCount(row)).keys()].map((x) => { return <RenderNumberOfCoApplicant key={x} {...props} num={x + 1} /> })}
                                </>
                            )}
                        </>
                    )}

                    <li className="formContentIVcol">
                        <div className="form1003ContentHead">Loan Officer Name</div>
                        <div className="usericon"></div>
                        <DropDown
                            errors={errors}
                            path={"loanOfficerId"}
                            value={Helper.ToString(row?.loanOfficerId)}
                            items={loanOfficers}
                            displayName={"text"}
                            displayValue={"value"}
                            onInputChildChanged={onInputChanged}
                            disabled={loanOffierDisabled}
                            dataRequired={true}
                            requiredMessage={"Loan Officer Name is required"}
                            indexValue={1}
                            onInputClicked={onInputClicked}
                        />
                    </li>

                    <li className="formContentIVcol">
                        <div className="form1003ContentHead">Select Property State<div className="formMandatory">*</div></div>
                        <div className="usericon"></div>
                        <DropDown
                            errors={errors}
                            path={"loanOfficerStateId"}
                            value={Helper.ToString(row?.loanOfficerStateId)}
                            items={statesList}
                            displayName={"text"}
                            displayValue={"value"}
                            onInputChildChanged={onInputChanged}
                            disabled={
                                !Helper.ToUndefinedCheck(row?.loanOfficerIndicator)
                            }
                            dataRequired={true}
                            requiredMessage={"State Name is required"}
                            indexValue={1}
                            onInputClicked={onInputClicked}
                        />
                    </li>

                    <li className="formContentIVcol">
                        <div className="form1003ContentHead">
                            How did you hear about us?
                        </div>
                        <div className="noteicon"></div>
                        <DropDown
                            errors={errors}
                            path={"howDoYouHear"}
                            value={Helper.ToString(row?.howDoYouHear)}
                            items={howdoyouhear}
                            displayName={"text"}
                            displayValue={"value"}
                            onInputChildChanged={onInputChanged}
                            onInputClicked={onInputClicked}
                            dataRequired={true}
                            requiredMessage={"How did you hear about us?"}
                            indexValue={1}
                        />
                    </li>

                    {row?.howDoYouHear === "Other" && (
                        <li className="formContentIVcol">
                            <div className="form1003ContentHead">Others</div>
                            <div className="textPad10">
                                <TextInput
                                    errors={errors}
                                    path={"howDoYouHearOthers"}
                                    value={Helper.ToString(row?.howDoYouHearOthers)}
                                    onInputChildChanged={onInputChanged}
                                    onBlurError={onBlurError}
                                    onInputClicked={onInputClicked}
                                    required={true}
                                    requiredMessage={'How did you hear about us?'}
                                    dataRequired={true}
                                />
                            </div>
                        </li>
                    )}
                    <li className="formContentIVcol"></li>

                </ul>
            </div>
        </>
    );
};

export default Component;